module.exports = __webpack_public_path__ + "img/queue.0f843925.png";